import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";

import { UserContext } from "../App";
import NotApprovedBanner from "../components/NotApprovedBanner";
import { canAccessPath } from "../services/rbacService";

import { RouteGuard } from "./utilities";
import SaccoRoutes from "./sacco-routing";

// page imports
const Dashboard = React.lazy(() => import("../pages/Dashboard"));
const CrewManager = React.lazy(() => import("../pages/Crew-Manager"));
const Login = React.lazy(() => import("../pages/Login"));
const Register = React.lazy(() => import("../pages/Register"));
const MatatuManager = React.lazy(() => import("../pages/Matatu-Manager"));
const FareChart = React.lazy(() => import("../pages/Farechart"));
const Trips = React.lazy(() => import("../pages/Trips"));
const Withdraw = React.lazy(() => import("../pages/Withdraw"));
const Profile = React.lazy(() => import("../pages/Profile"));
const Operators = React.lazy(() => import("../pages/Operators"));
const SavingsPage = React.lazy(() => import("../pages/Savings"));
const ParcelPage = React.lazy(() => import("../pages/Parcel"));
const Notifications = React.lazy(() => import("../pages/Notifications"));
const ChatMessages = React.lazy(() =>
  import("../pages/Notifications/ChatComponent")
);
const Loans = React.lazy(() => import("../pages/Loans"));

const OperatorsPageForRole = () => {
  const user = useContext(UserContext)?.saccoUser;
  if (!canAccessPath(user, "/operators")) {
    return (
      <NotApprovedBanner message="Sorry you are not allowed to access this page." />
    );
  }
  return <Operators />;
};

const Routing = ({ auth }) => {
  return (
    <Routes>
      <Route
        path="withdraw"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <Withdraw />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="notifications/:recipient"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <ChatMessages />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="notifications"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <Notifications />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="Savings"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <SavingsPage />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="crew-manager"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <CrewManager />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="matatu"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <MatatuManager />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="parcel-service"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <ParcelPage />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="transactions"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <Trips />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="farechart"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <FareChart />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="loans"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <Loans />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="login"
        element={
          <React.Suspense fallback={<>..</>}>
            <Login />
          </React.Suspense>
        }
      />
      <Route
        path="register"
        element={
          <React.Suspense fallback={<>..</>}>
            <Register />
          </React.Suspense>
        }
      />

      <Route
        path="profile"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <Profile />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route
        path="operators"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <OperatorsPageForRole />
            </RouteGuard>
          </React.Suspense>
        }
      />
      <Route path="/sacco/*" element={<SaccoRoutes auth={auth} />} />

      <Route
        path="/"
        element={
          <React.Suspense fallback={<>..</>}>
            <RouteGuard auth={auth}>
              <Dashboard />
            </RouteGuard>
          </React.Suspense>
        }
      />

      {/* <SaccoRoutes /> */}
    </Routes>
  );
};

export default Routing;
